export default (state = {}, {}) => {
  return {
    ...state,
    edge365: {},
  };
};
